import React from "react";
import { useNavigate } from "react-router-dom";

export default function BillingSuccess() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          maxWidth: 720,
          margin: "40px auto",
          background: "#13293d",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: 16,
          padding: 32,
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 46, marginBottom: 12 }}>🎉</div>

        <h1 style={{ marginTop: 0, color: "#ffffff" }}>
          Welcome to JobTelesis Basic
        </h1>

        <p style={{ color: "#dbeafe", fontSize: 18 }}>
          Your subscription checkout completed successfully.
        </p>

        <div
          style={{
            margin: "24px auto",
            textAlign: "left",
            color: "#dbeafe",
            lineHeight: 1.8,
            maxWidth: 520,
          }}
        >
          <div>✓ Your workspace is being unlocked.</div>
          <div>✓ Billing has been connected through Stripe.</div>
          <div>✓ You can continue using JobTelesis.</div>
        </div>

        <button
          onClick={() => navigate("/clients-jobs")}
          style={{
            marginTop: 12,
            padding: "12px 18px",
            background: "#e0b84f",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            fontWeight: 800,
            color: "#0b1b2b",
          }}
        >
          Continue to JobTelesis
        </button>

        <p style={{ marginTop: 22, color: "#9fb0c3", fontSize: 14 }}>
          If your workspace does not unlock immediately, refresh once. Stripe webhooks can take a few seconds.
        </p>
      </div>
    </div>
  );
}
